<template>
    <div class="host-change-warning">
        <div class="panel">
            <img class="logo" src="https://www.sokuji.tw/_files/app-use/sokuji_color.svg" alt="" />
            <div class="title">ahoo 已更名為 Sokuji</div>
            <div class="description">提醒您，https://app.ahoo.tw 網域將於 9/20 將關閉，請您改用新網址進入系統： <a :href="url" class="newUrl">https://app.sokuji.tw</a></div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        url() {
            const company = this.$store.getters['account/company'];
            const email = this.$store.getters['account/email'];
            const urlQuery = [];
            if (company) {
                urlQuery.push(`company_id=${company}`);
            }
            if (email) {
                urlQuery.push(`email=${email}`);
            }
            const basetUrl = 'https://app.sokuji.tw/login';
            if (urlQuery.length > 0) {
                return `${basetUrl}?${urlQuery.join('&')}`;
            }
            return basetUrl;
        },
    },
};
</script>
<style lang="scss">
.host-change-warning {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 999999;

    >.panel {
        display: block;
        max-width: 600px;
        color: #fff;
        background-color: #222;
        padding: 50px 50px 80px 50px;
        border-radius: 20px;
        margin: 12px;

        >.logo {
            display: block;
            width: 60%;
            margin: 40px auto 70px auto;
        }

        >.title {
            font-size: 17pt;
            font-weight: bold;
            margin-bottom: 20px;
            text-align: center;
        }
        >.description {
            font-size: 12pt;
            line-height: 180%;
            margin: 0 auto;
            max-width: 400px;
        }

        .newUrl {
            display: block;
            font-size: 15pt;
            font-weight: bold;
            color: #0464ff;
            text-decoration: none;
            text-align: center;
            background-color: #e9f1ff;
            padding: 8px 10px;
            border-radius: 8px;
            margin-top: 15px;
        }
    }
}
</style>
